import React, {Component} from 'react';
import {Link} from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import {FaEdit, FaStopCircle, FaTrash} from "react-icons/fa";
import {Dropdown} from "react-bootstrap";

class ListHostingByUserComponent extends Component {

    loadStatus = () => {
        if ( this.props.service.status_hosting === 'on' ) {
            return (
                <span className="text-success">
                    Đang bật
                </span>
            )
        }
        else if ( this.props.service.status_hosting === 'off' ) {
            return (
                <span className="text-danger">
                    Đã tắt
                </span>
            )
        }
        else if ( this.props.service.status_hosting === 'admin_off' ) {
            return (
                <span className="text-danger">
                    Admin tắt
                </span>
            )
        }
        else if ( this.props.service.status_hosting === 'progressing' ) {
            return (
                <span className="text-info">
                    Đang tạo
                </span>
            )
        }
        else if ( this.props.service.status_hosting === 'waiting' ) {
            return (
                <span className="text-info">
                    Đang chờ tạo
                </span>
            )
        }
        else if ( this.props.service.status_hosting === 'rebuild' ) {
            return (
                <span className="text-info">
                    Đang tạo lại
                </span>
            )
        }
        else if ( this.props.service.status_hosting === 'reset_password' ) {
            return (
                <span className="text-info">
                    Đang đặt lại mật khẩu
                </span>
            )
        }
        else if ( this.props.service.status_hosting === 'change_ip' ) {
            return (
                <span className="text-info">
                    Đang đổi IP
                </span>
            )
        }
        else if ( this.props.service.status_hosting === 'expire' ) {
            return (
                <span className="text-danger">
                    Hết hạn
                </span>
            )
        }
        else if ( this.props.service.status_hosting === 'cancel' ) {
            return (
                <span className="text-danger">
                    Đã hủy
                </span>
            )
        }
        else if ( this.props.service.status_hosting === 'delete' ) {
            return (
                <span className="text-danger">
                    Đã xóa
                </span>
            )
        }
        else if ( this.props.service.status_hosting === 'change_user' ) {
            return (
                <span className="text-danger">
                    Đã chuyển
                </span>
            )
        }
        else {
            return (
                <span className="text-danger">
                    Chưa tạo
                </span>
            )
        }
    }

    checkedService = (event) => {
        if ( event.nativeEvent.shiftKey ) {
            let value = event.target.checked;
            this.props.checkedServiceShiftKey( this.props.actionKey, value );
        } else {
            this.props.checkedService( this.props.actionKey );
        }
    }

    render() {
        return (
            <tr>
                <td>
                    <input type="checkbox" value="1" checked={this.props.service.checked}  onChange={ this.checkedService } />
                </td>
                <td>
                    <Link to={'/admin/hosting/' + this.props.service.id + '/chinh-sua.html'}>{this.props.service.domain}</Link>
                </td>
                <td>
                    <Link to={'/admin/san-pham/chinh-sua-san-pham/' + this.props.service.product_id}>{this.props.service.product_name}</Link>
                </td>
                <td>
                    { this.props.service.text_create_date }
                </td>
                <td>
                    { this.props.service.text_next_due_date }
                </td>
                <td>
                    { this.props.service.text_total_time }
                </td>
                <td>
                    { this.props.service.text_billing_cycle }
                </td>
                <td>
                    { this.props.service.text_amount }
                </td>
                <td>
                    { this.loadStatus() }
                </td>
                <td>
                    <OverlayTrigger
                        delay={{ hide: 450, show: 300 }}
                        overlay={(props) => (
                            <Tooltip {...props}>
                                Chỉnh sửa VPS
                            </Tooltip>
                        )}
                        placement="top"
                    >
                        <Link to={'/admin/hosting/' + this.props.service.id + '/chinh-sua.html'} className="btn btn-warning btn-sm mr-1 text-light">
                            <FaEdit />
                        </Link>
                    </OverlayTrigger>
                    {
                        this.props.service.status_hosting === 'off' || this.props.service.status_hosting === 'on' ? (
                            <>
                                <OverlayTrigger
                                    delay={{ hide: 450, show: 300 }}
                                    overlay={(props) => (
                                        <Tooltip {...props}>
                                            Hành động
                                        </Tooltip>
                                    )}
                                    placement="top"
                                >
                                    <Dropdown className="btn mr-1 p-0">
                                        <Dropdown.Toggle variant="success" id="dropdown-basic" className="btn-sm">
                                            <FaStopCircle />
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {
                                                this.props.service.status_hosting === 'off' ? (
                                                    <>
                                                        <Dropdown.Item onClick={ () => this.props.showModal( this.props.actionKey, 'on' ) }>Bật</Dropdown.Item>
                                                    </>
                                                ) : (
                                                    <></>
                                                )
                                            }
                                            {
                                                this.props.service.status_hosting === 'on' ? (
                                                    <>
                                                        {/*<Dropdown.Item onClick={ () => this.props.cosole( this.props.actionKey ) }>Truy cập Console</Dropdown.Item>*/}
                                                        <Dropdown.Item onClick={ () => this.props.showModal( this.props.actionKey, 'off' ) }>Tắt</Dropdown.Item>
                                                    </>
                                                ) : (
                                                    <></>
                                                )
                                            }
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </OverlayTrigger>
                            </>
                        ) : (
                            <></>
                        )
                    }
                    {
                        this.props.service.status_hosting === 'off' || this.props.service.status_hosting === 'on'
                        || this.props.service.status_hosting === 'expire' || this.props.service.status_hosting === 'waiting' ? (
                            <OverlayTrigger
                                delay={{ hide: 450, show: 300 }}
                                overlay={(props) => (
                                    <Tooltip {...props}>
                                        Xóa Hosting
                                    </Tooltip>
                                )}
                                placement="top"
                            >
                                <button type="button" className="btn btn-danger btn-sm mr-1" onClick={ () => this.props.showModal( this.props.actionKey, 'delete' ) }>
                                    <FaTrash />
                                </button>
                            </OverlayTrigger>
                        ) : (
                            <></>
                        )
                    }
                </td>
            </tr>
        );
    }
}

export default ListHostingByUserComponent;